import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatbotFab from './components/ChatbotFab';
import ChatbotWidget from './components/ChatbotWidget';
import ScrollTopFab from './components/ScrollTopFab';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Infrastructure from './pages/Infrastructure';
import Products from './pages/Products';
import SolutionDetail from './pages/SolutionDetail';
import Clients from './pages/Clients';
import Quality from './pages/Quality';
import Contact from './pages/Contact';
import './index.css';

// Scroll to top and handle hash anchors on route change
const ScrollHandler = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          const offset = 80;
          const top = el.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [chatDraft, setChatDraft] = useState('');

  useEffect(() => {
    const onOpenChat = (e) => {
      const msg = e?.detail?.message;
      if (typeof msg === 'string' && msg.trim()) setChatDraft(msg.trim());
      setIsChatOpen(true);
    };
    window.addEventListener('c2p:openChat', onOpenChat);
    return () => window.removeEventListener('c2p:openChat', onOpenChat);
  }, []);

  return (
    <Router>
      <div style={{ position: 'relative', zIndex: 1 }}>
      <ScrollHandler />
      <Navbar />
      <div style={{ paddingTop: '72px' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/infrastructure" element={<Infrastructure />} />
          <Route path="/solutions" element={<Products />} />
          <Route path="/solutions/:id" element={<SolutionDetail />} />
          <Route path="/products" element={<Navigate to="/solutions" replace />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/quality" element={<Quality />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
      <Footer />
      <ScrollTopFab />
      <ChatbotWidget
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
        draftMessage={chatDraft}
        onDraftConsumed={() => setChatDraft('')}
      />
      <ChatbotFab
        isOpen={isChatOpen}
        onToggle={() => setIsChatOpen((v) => !v)}
      />
      </div>
    </Router>
  );
}

export default App;
